export const designSystemColors = {
  cedar: 'rgba(64, 83, 69, 1)',
  cedarShade: 'rgba(44, 58, 47, 1)',
  cedarTint: 'rgba(89, 112, 94, 1)',
  charcoal: 'rgba(35, 36, 38, 1)',
  lake: 'rgba(155, 196, 206, 1)',
  lakePop: 'rgba(143, 215, 233, 1)',
  lakeShade: 'rgba(115, 146, 156, 1)',
  lakeTint: 'rgba(202, 233, 237, 1)',
  lavender: 'rgba(201, 174, 241, 1)',
  lavenderLight: 'rgba(236, 223, 255, 1)',
  lavenderMidTint: 'rgba(184, 159, 220, 1)',
  lavenderShade: 'rgba(162, 135, 202, 1)',
  lavenderTint: 'rgba(222, 205, 247, 1)',
  lemon: 'rgba(249, 253, 153, 1)',
  lightSand: 'rgba(255, 250, 243, 1)',
  ocean: 'rgba(0, 80, 119, 1)',
  poppy: 'rgba(239, 99, 81, 1)',
  poppy06: 'rgba( 217, 80, 62, 1)',
  poppyLight: 'rgba(249, 193, 185, 1)',
  poppyMidTint: 'rgba(255, 138, 123, 1)',
  poppyShade: 'rgba( 191 ,68, 53, 1)',
  poppyTint: 'rgba(255, 167, 156, 1)',
  sage: 'rgba(187, 199, 182, 1)',
  sageLight: 'rgba(220, 227, 212, 1)',
  sageMidTint: 'rgba(166, 189, 158, 1)',
  sageShade: 'rgba(150, 171, 142, 1)',
  sageTint: 'rgba(207, 214, 200, 1)',
  sageTint2: 'rgba(226, 239, 211, 1)',
  sand: 'rgba(233, 220, 198, 1)',
  sandShade: 'rgba(214, 202, 183, 1)',
  sandTint: 'rgba(244, 235, 220, 1)',
  storm: 'rgba(109, 119, 126, 1)',
  stormShade: 'rgba(66, 72, 76, 1)',
  stormTint: 'rgba(175, 175, 175, 1)',
  transparent: 'transparent',
  white: 'rgba(255, 255, 255, 1)',
} as const;

export type DesignSystemColorTypes = keyof typeof designSystemColors;
export type TDesignSystemColorValues = typeof designSystemColors[DesignSystemColorTypes];
export type TNamedBackgroundColors = 'dark' | 'light' | 'charcoal' | 'lightSand' | 'white';

export type TDesignSystemColors = {
  charcoal?: 'rgba(35, 36, 38, 1)';
  lavender?: 'rgba(201, 174, 241, 1)';
  lavenderShade?: 'rgba(162, 135, 202, 1)';
  lemon?: 'rgba(249, 253, 153, 1)';
  lightSand?: 'rgba(255, 250, 243, 1)';
  ocean?: 'rgba(0, 80, 119, 1)';
  poppy?: 'rgba(239, 99, 81, 1)';
  sage?: 'rgba(187, 199, 182, 1)';
  sageShade?: 'rgba(150, 171, 142, 1)';
  sageTint?: 'rgba(207, 214, 200, 1)';
  sand?: 'rgba(233, 220, 198, 1)';
  sandShade?: 'rgba(214, 202, 183, 1)';
  sandTint?: 'rgba(244, 235, 220, 1)';
  white?: 'rgba(255, 255, 255, 1)';
  transparent?: 'transparent';
};

export const designSystemColorNames = Object.keys(designSystemColors);

export const otherColors = {
  accordionBorderGray: 'rgb(205 206 206)',
  charcoal20: 'rgba(35, 36, 38, 0.20)',
  charcoal50: 'rgba(35, 36, 38, 0.50)',
  ghostActiveGray: 'rgba(237, 237, 237, 1)',
  navBorderGray: 'rgba(35, 36, 38, .2)',
  navDescriptionGray: 'rgba(130, 130, 130, 1)',
  gray40: 'rgba(223, 227, 230, 1)',
  gray50: 'rgba(223, 227, 230, 0.5)',
  gray70: 'rgba(145, 151, 159, 1)',
  gray90: 'rgba(79, 82, 86, 1)',
  inputFieldBackground: 'rgba(62, 59, 55, 1)',
  inputFieldBoxShadow: 'rgba(16, 24, 40, 0.05)',
  inputText: 'rgba(55, 63, 71, 1)',
  archiveCardBoxShadow: 'rgba(16, 24, 40, 0.1)',
  neutral500: 'rgba(107, 114, 128, 1)',
  neutral900: 'rgba(17, 24, 39, 1)',
  placeholderText: 'rgba(185, 185, 185, 1)',
  fadedCharcoal: 'rgba(35, 36, 38, 0.1)',
  fadedCharcoal15: 'rgba(35, 36, 38, 0.15)',
  fadedCharcoal20: 'rgba(35, 36, 38, 0.2)',
  fadedWhite: 'rgba(255, 255, 255, 0.1)',
  fadedWhite20: 'rgba(255, 255, 255, 0.2)',
  checkBoxHoverBackground: 'rgba(255, 255, 255, 0.2)',
  playButtonBackground: 'rgba(0, 0, 0, 0.5)',
  errorRed: 'rgba(239, 68, 68, 1)',
  relatedContentCardDarkBorder: 'rgba(255, 255, 255, 0.2)',
  lightBorder: 'rgba(35, 36, 38, 0.2)',
  darkBorder: 'rgba(255, 255, 255, 0.2)',
  background: designSystemColors.white,
  logo: designSystemColors.charcoal,
  text: designSystemColors.charcoal,
  // klaviyo one colors
  accordionBorderCedar: 'rgba(44, 58, 47, .2)',
  accordionBorderWhite: 'rgba(255, 255, 255, .2)',
  fadedCedar: 'rgba(64, 83, 69, 0.1)',
  fadedCedarShade: 'rgba(44, 58, 47, 0.1)',
  // inputFieldBackground: 'rgba(242, 244, 245, 1)',
  inputPlaceholderText: 'rgba(44, 58, 47, 0.5)',
  navigationBorder: 'rgba(64, 83, 69, .1)',
} as const;

export type OtherColorTypes = keyof typeof otherColors;
export type TOtherColorValues = typeof otherColors[OtherColorTypes];

export type TAllColorNames = DesignSystemColorTypes | OtherColorTypes;
export type TAllColorValues = TDesignSystemColorValues | TOtherColorValues;
export const otherColorsNames = Object.keys(otherColors);
